module.exports = __webpack_public_path__ + "img/exterior-sample-1.136e7a75.jpg";